export const ShimmerLoader = () => (
    <div className="p-24">
        <div
            style={{
                backgroundColor: '#e0e0e0',
                height: '20px',
                width: '60%',
                marginBottom: '12px',
                borderRadius: '8px',
            }}
            className="animate-pulse"
        />
        <div
            style={{
                backgroundColor: '#e0e0e0',
                height: '14px',
                width: '90%',
                marginBottom: '8px',
                borderRadius: '6px',
            }}
            className="animate-pulse"
        />
        <div
            style={{
                backgroundColor: '#e0e0e0',
                height: '14px',
                width: '85%',
                borderRadius: '6px',
            }}
            className="animate-pulse"
        />
    </div>
);